export default "__VITE_ASSET__BBapcvh7__"